import { createFileRoute, redirect } from '@tanstack/react-router'
import { FEATURES, isFeatureEnabled } from '@/utils/feature-flag.ts'
import { Stack } from '@mui/material'
import { FleetTracking } from '@/features/fleet/components/layout/FleetTracking.tsx'
import { PageHeader } from '@/components/PageHeader/PageHeader.tsx'
import { useTranslation } from 'react-i18next'
import i18n from '@/i18n.ts'
import { z } from 'zod'

export const Route = createFileRoute('/_authenticated/$companySlug/fleet-tracking/')({
  beforeLoad: ({ context }) => {
    if (!isFeatureEnabled(FEATURES.FLEET_TRACKING)) {
      throw redirect({ to: '/not-found' })
    }
    context.auth.rejectIfMissingPermissions(['VEHICLE_READ'])
  },
  validateSearch: z.object({
    vin: z.string().optional()
  }),
  head: () => ({
    meta: [{ title: i18n.t('_routes:routes.fleet_tracking.main.title') }]
  }),
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation('_routes')
  const { sites: filterSites, vin } = Route.useSearch()
  const navigate = Route.useNavigate()

  const onVinToTrackSelected = (vin?: string) => {
    navigate({
      search: prev => ({
        ...prev,
        vin: vin
      })
    })
  }

  return (
    <Stack spacing={3}>
      <PageHeader>{t('routes.fleet_tracking.main.title')}</PageHeader>
      <FleetTracking
        siteIds={filterSites}
        trackedVehicleVin={vin}
        onSelectVinToTrack={onVinToTrackSelected}
      />
    </Stack>
  )
}
